import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { SearchPage } from '../components/Views/SearchPage';
import { SearchItemsPaginationSection } from '../components/Sections/SearchItemsPaginationSection';
import { PaginationLinks } from '../components/PaginationLinks';
import { getLocaleFromBrowser } from '../utils/helpers';
import Layout from '../components/Layout/Layout';
import {
  fetchSearchCursorPageProps,
  fetchRegularSearchPageProps
} from '../utils/helpers/searchPageFetcher';
import CONFIG from '../config';

const Search = ({
  transformedObj,
  h1,
  breadcrumbs,
  isSearchPage,
  nextPageUrl,
  prevPageUrl,
  noindex,
  canonicalUrl,
  isPaginationPage,
  items
}) => {
  if (isPaginationPage) {
    return (
      <>
        <PaginationLinks nextPageUrl={nextPageUrl} prevPageUrl={prevPageUrl} />
        <SearchItemsPaginationSection items={items} />
      </>
    );
  }

  const safeTransformedObj = transformedObj || { filter: {} };
  return (
    <>
      <Head>
        {noindex && (
          <meta key="robots" name="robots" content="noindex,follow" />
        )}
        {canonicalUrl && (
          <link key="canonical" rel="canonical" href={canonicalUrl} />
        )}
      </Head>
      <PaginationLinks nextPageUrl={nextPageUrl} prevPageUrl={prevPageUrl} />
      <SearchPage
        transformedObj={safeTransformedObj}
        h1={h1}
        breadcrumbs={breadcrumbs}
        isSearchPage={isSearchPage}
      />
    </>
  );
};

Search.getInitialProps = async ({
  apolloClient,
  asPath,
  query,
  res,
  req,
  store,
  lng: ctxLng
}) => {
  const currentLang =
    (typeof window !== 'undefined' ? getLocaleFromBrowser() : ctxLng) ||
    CONFIG.defaultLocale;

  const afterCursor = query.after || null;

  if (afterCursor) {
    return fetchSearchCursorPageProps({ apolloClient, query, asPath, res });
  }

  return fetchRegularSearchPageProps({
    apolloClient,
    query,
    asPath,
    req,
    res,
    store,
    currentLang
  });
};

Search.propTypes = {
  transformedObj: PropTypes.object,
  breadcrumbs: PropTypes.array,
  h1: PropTypes.string,
  seoData: PropTypes.object,
  isSearchPage: PropTypes.bool,
  currentLang: PropTypes.oneOf(['az', 'ru']),
  nextPageUrl: PropTypes.string,
  prevPageUrl: PropTypes.string,
  noindex: PropTypes.bool,
  canonicalUrl: PropTypes.string,
  isPaginationPage: PropTypes.bool,
  items: PropTypes.array
};

Search.getLayout = (page, pageProps) => {
  if (pageProps.isPaginationPage) return page;

  return (
    <Layout isBackgroundBanner isBanner pageProps={pageProps}>
      {page}
    </Layout>
  );
};

export default Search;
